import { createContext, useContext } from "react";

type BookOutletScopeContextValue = {
    inBookOutlet: boolean;
};

const BookOutletScopeContext = createContext<BookOutletScopeContextValue>({ inBookOutlet: false });

export const BookOutletScopeProvider = BookOutletScopeContext.Provider;

export const useBookOutletScope = (): BookOutletScopeContextValue => useContext(BookOutletScopeContext);
